<div
    [ngClass]="{
        'full-size': !currentNode?.orgCode,
        active: isActive,
        disabled: isDisabled && !isParent,
        deactivated: currentNode.deactivated,
        'disabled-parent': isDisabled && isParent
    }"
    class="node-item"
>
    <div (click)="changeNode(currentNode)" class="node-main">
        <div class="org-code">
            <span class="text">{{ currentNode?.orgCode }}</span>
        </div>
        <div class="node-content">
            <div class="org-name-wrapper">
                <span class="org-name text" style="font-size: 20px">{{ currentNode?.orgDescription }}</span>
            </div>
            <div class="rsp-name-wrapper">
                <span class="rsp-name text" style="font-size: 14px">
                    {{ specialistFullName || responsibleFullName }}
                </span>
            </div>
        </div>
    </div>
    @if (currentNode?.orgCode) {
        <div class="node-footer">
            <div (click)="openNode.emit(currentNode)" class="reports">
                <span class="icon-document-text"></span>
                <span style="margin-left: 10px">
                    {{ currentNode?.reportCount || ('report.item.noItems' | translate) }}
                </span>
            </div>
            @if (currentNode?.childrenCount) {
                <div (click)="changeNode(currentNode)" class="reports">
                    <fa-icon [icon]="['fas', 'sitemap']"></fa-icon>
                    <span style="margin-left: 10px">
                        {{ currentNode?.childrenCount }}
                    </span>
                </div>
            }
            @if (!isDisabled) {
                <!-- <div sag-ui-menu-trigger menuTriggerFor="options-menu" class="node-footer-button">
          <span class="icon-options-vertical"></span>
        </div> -->
                <div [matMenuTriggerFor]="menu" class="node-footer-button">
                    <span class="icon-options-vertical"></span>
                </div>
            }
        </div>
    }
</div>

<!-- <sag-ui-menu menu="options-menu">
  <sag-ui-menu-item (click)="openNode.emit(currentNode); test(currentNode)">
    <div class="menu-icon-container">
      <span class="icon-circle-information"></span>
    </div>
    <span>{{ "organisation.dropdown.information" | translate }}</span>
  </sag-ui-menu-item>

  @if (isEditActive) {
    <sag-ui-menu-item (click)="editNode.emit(currentNode)">
      <div class="menu-icon-container">
        <span class="icon-edit"></span>
      </div>
      <span>{{ "organisation.dropdown.edit" | translate }}</span>
    </sag-ui-menu-item>

    @if (hasCurrentReport) {
      <sag-ui-menu-item (click)="reset.emit(currentNode)">
        <div class="menu-icon-container">
          <span class="icon-reset"></span>
        </div>
        <span>{{ "organisation.dropdown.resetReport" | translate }}</span>
      </sag-ui-menu-item>

      <sag-ui-menu-item (click)="unPublish.emit(currentNode)">
        <div class="menu-icon-container">
          <span class="icon-undo"></span>
        </div>
        <span>{{ "organisation.dropdown.unpublishReport" | translate }}</span>
      </sag-ui-menu-item>
    }

    @if (!isParent && !currentNode?.childrenCount) {
      <sag-ui-menu-item (click)="deleteNode.emit(currentNode)" class="menu-danger">
        <div class="menu-icon-container">
          <span class="icon-delete"></span>
        </div>
        <span>{{ "organisation.dropdown.delete" | translate }}</span>
      </sag-ui-menu-item>
    }
  }
</sag-ui-menu> -->

<mat-menu #menu="matMenu" class="thin-mat-menu">
    <button (click)="openNode.emit(currentNode)" mat-menu-item>
        <div class="menu-icon-container">
            <span class="icon-circle-information"></span>
        </div>
        <span>{{ 'organisation.dropdown.information' | translate }}</span>
    </button>
    @if (isEditActive) {
        @if (!currentNode.deactivated) {
            <button (click)="editNode.emit(currentNode)" mat-menu-item>
                <div class="menu-icon-container">
                    <span class="icon-edit"></span>
                </div>
                <span>{{ 'organisation.dropdown.edit' | translate }}</span>
            </button>

            @if (hasCurrentReport) {
                <button (click)="reset.emit(currentNode)" mat-menu-item>
                    <div class="menu-icon-container">
                        <span class="icon-reset"></span>
                    </div>
                    <span>{{ 'organisation.dropdown.resetReport' | translate }}</span>
                </button>

                <button (click)="unPublish.emit(currentNode)" mat-menu-item>
                    <div class="menu-icon-container">
                        <span class="icon-undo"></span>
                    </div>
                    <span>{{ 'organisation.dropdown.unpublishReport' | translate }}</span>
                </button>
            }
        }

        @if (guardService.isAdmin) {
            <button (click)="toggleDeactivationState()" mat-menu-item>
                <div class="menu-icon-container">
                    <span [ngClass]="currentNode.deactivated ? 'icon-view' : 'icon-view-off'"></span>
                </div>
                <span>{{
                    (currentNode.deactivated ? 'organisation.dropdown.activate' : 'organisation.dropdown.deactivate')
                        | translate
                }}</span>
            </button>
        }

        @if (!isParent && !currentNode?.childrenCount) {
            <button (click)="deleteNode.emit(currentNode)" class="menu-danger" mat-menu-item>
                <div class="menu-icon-container">
                    <span class="icon-delete"></span>
                </div>
                <span>{{ 'organisation.dropdown.delete' | translate }}</span>
            </button>
        }
    }
</mat-menu>
